import { isWeixin } from "./common"

const routes = [{
  path: "/liveCourse",
  name: "liveCourse",
  meta: {
    title: "实时直播",
    isLogin: true,
    showTab: true,
    top:80
  },
  component: () => import("@/pages/liveCourse/liveCourse"),
},
{
  path: "/user",
  name: "user",
  meta: { title: "个人中心", isLogin: false, showHead:true, showTab: true },
  component: () => import("@/pages/user/User"),
},
{
  path: "/courseInfo",
  name: "courseInfo",
  meta: { title: "课程详情", isLogin: true },
  component: () => import("@/pages/courseInfo/CourseInfo"),
},
{
  path: '/clear',
  name: 'clear',
  meta: {title: '清除缓存'},
  component:()=> import("@/pages/clear/clear"),
},
{
  path: '/test',
  name: 'test',
  // meta: {title: 'test'},
  component:()=> import("@/pages/test/test"),
},
{
  path: '/hLive', // 横屏直播
  name: 'hlive',
  meta: {title: '直播课程', isLogin: true},
  component:()=> import("@/pages/horizontalScreen/live")
},
{
  path: '/hReload', // 横屏回放
  name: 'hReload',
  meta: {title: '直播回放', isLogin: true},
  component:()=> import("@/pages/horizontalScreen/reload")
},
{
  path: '/vReload', // 录播的
  name: 'vReload',
  meta: {title: '录播详情', isLogin: true},
  component:()=> import("@/pages/verticalScreen/reload")
},
{
  path: '/vReload2', // 竖屏回放
  name: 'vReload2',
  meta: {title: '直播回放', isLogin: true},
  component:()=> import("@/pages/verticalScreen/reload2")
},
{
  path: '/vLive', // 竖屏直播
  name: 'vLive',
  meta: {title: '直播课程', isLogin: true},
  component:()=> import("@/pages/verticalScreen/live")
},
{
  path: '/buyProduct',
  name: 'buyProduct',
  meta: {title: '购买知识套餐', isLogin: isWeixin()? true : false, showHead:true},
  component:()=> import("@/pages/product/index"),
},
{
  path: '/ticket',
  name: 'ticket',
  meta: {title: '选择优惠券', isLogin: isWeixin()? true : false},
  component:()=> import("@/pages/ticket/index"),
},
{
  path: '/myCourse',
  name: 'myCourse',
  meta: {
    title: '我的专栏',
    isLogin: true,
    showTab: true,
    top:50
  },
  component: () => import("@/pages/myCourse/myCourse"),
},
{
  path: '/replay',
  name: 'replay',
  meta: {
    title: '课程列表',
    isLogin: true,
  },
  component: () => import("@/pages/myCourse/replay"),
},
{
  path: '/article',
  name: 'article',
  meta: {
    title: '图文课程',
    isLogin: true,
    showHead:true
  },
  component: () => import("@/pages/article/article"),
},
{
  path: '/receive-coupons',
  name: 'receive-coupons',
  meta: {
    title: '领取优惠券',
    isLogin: true,
    showHead:true
  },
  component: () => import("@/pages/receiveCoupons/receive"),
},
{
  path: '/receive-product',
  name: 'receive-product',
  meta: {
    title: '领取知识套餐',
    isLogin: true,
  },
  component: () => import("@/pages/receiveCoupons/receiveProduct"),
},
{
path: '/order',
name: 'order',
meta: {
  title: '我的订单',
  isLogin: true,
  top:0,
  showTab: true,
  keepAlive: true,
},
component: () => import("@/pages/user/order"),  
},
{
  path: '/study',
  name: 'study',
  meta: {
    title: '学习记录',
    isLogin: true,
    showTab: true
  },
  component: () => import("@/pages/user/study"),  
},
{
  path: '/qusList',
  name: 'qusList',
  meta: {
    title: '我的问卷',
    isLogin: true,
    showTab: true
  },
  component: ()=> import('@/pages/user/qusList')
},
{
  path: '/discounts',
  name: 'discounts',
  meta: {
    title: '优惠券',
    isLogin: true,
    showTab: true
  },
  component: () => import("@/pages/user/discounts"),  
},
{
  path: '/orderStatus',
  name: 'orderStatus',
  meta: {
    title: '订单状态',
  isLogin: isWeixin()? true : false,
  },
  component: () => import("@/pages/user/orderStatus"),  
},
{
  path: '/questionnaire',
  name: 'questionnaire',
  meta: {
    title: '问卷答题',
  isLogin: true,
  },
  component: () => import("@/pages/questionnaire/questionnaire"),  
},
{
  path: '/question',
  name: 'question',
  meta: {
    title: '问卷答题',
  isLogin: true,
  },
  component: () => import("@/pages/questionnaire/question"),  
},
{
  path: '/result',
  name: 'result',
  meta: {
    title: '测评结果',
    isLogin: true,
  },
  component: () => import("@/pages/questionnaire/result"),  
},
{
  path: '/analysis',
  name: 'analysis',
  meta: {
    title: '答案解析',
    isLogin: true,
  },
  component: () => import("@/pages/questionnaire/analysis"),  
},
{
  path: '/formSet',
  name: 'formSet',
  meta: {
    title: '问卷调查',
  isLogin: true,
  },
  component: () => import("@/pages/questionnaire/formSet"),  
},
{
  path: '/toBill',
  name: 'toBill',
  meta: {
    title: '开票',
    isLogin: true,
  },
  component: () => import("@/pages/bill/bill")  
},
{
  path: '/address',
  name: 'address',
  meta:{
    title: '收货地址',
    isLogin: isWeixin()? true : false
  },
  component: () => import("@/pages/user/userAddress")
},
{
  path: '/createOrder',
  meta: {
    title: '生成订单',
    isLogin: isWeixin()? true : false,
    // showHead:true
  },
  component:() => import("@/pages/buy/createOrder") 
},
{
  path: '/success',
  meta:{
    title: '支付成功'
  },
  component:()=>import("@/pages/buy/success")
},
{
  path: '/group',
  meta:{
    title: '支付成功'
  },
  component:()=>import("@/pages/buy/group")
},
{
  path: '/orderInfo',
  name: 'orderInfo',
  meta: {
    title: '订单详情',
    isLogin: true,
  },
  component:()=>import("@/pages/buy/orderInfo")
},
{
  path: '/scoreList',
  name: 'scoreList',
  meta: {
    title: '明细',
    isLogin: true,
  },
  component:()=>import("@/pages/user/scoreList")
},
{
  path: '/score-mentions',
  name: 'score-mentions',
  meta: {
    title: '学分规则',
  },
  component:()=>import("@/pages/user/scoreMentions")
},
{
  path: '/my-class',
  name: 'my-class',
  meta: {
    title: '我的同学',
    isLogin: true
  },
  component:()=>import("@/pages/user/myClass")
},
{
  path: '/score-center',
  name: 'score-center',
  meta: {
    title: '学分中心',
    isLogin: true,
    keepAlive: true,
  },
  component:()=>import("@/pages/score/center")
},
{
  path: '/score-record',
  name: 'score-record',
  meta: {
    title: '学分记录',
    isLogin: true,
    keepAlive: true
  },
  component:()=>import("@/pages/score/record")
},
{
  path: '/pdinfo',
  name: 'pdinfo',
  meta: {
    title: '商品详情',
    isLogin: true,
  },
  component:()=>import("@/pages/score/pdinfo")
},
{
  path:'*',
  meta: {
   title: '个人中心',
   isLogin: true,
   showTab: true
 },
 component: () => import("@/pages/user/User")
},
{
  path: '/login',
  meta: {
    title: '登录',
  },
  component:()=>import("@/pages/login/login")
},
{
  path: '/home',
  meta: {
    title: '首页',
    showTab: true
  },
  component:()=>import("@/pages/home")
},
{
  path: '/rich-details',
  meta: {
    title: '首页详情',
    keepAlive: true
  },
  component:()=>import("@/pages/home/richDetails")
},
{
  path: '/certificate-list',
  name: 'certificateList',
  meta: {
    title: '证书列表',
    isLogin: true,
  },
  component:()=>import("@/pages/certificateList/index")
},
{
  path: '/certificate-details',
  name: 'certificateDetails',
  meta: {
    title: '证书详情',
    isLogin: true,
  },
  component:()=>import("@/pages/certificateList/details")
},
{
  path: '/risk',
  name: 'risk',
  meta: {
    title: '',
    isLogin: true,
  },
  component:()=>import("@/pages/risk/risk")
},
{
  path: '/webview',
  component:()=>import("@/pages/webview/index")
},
{
  path: '/downloadApp',
  component:()=>import("@/pages/download/download")
},
{
  path: '/contract-list',
  meta: {
    title: '订单合同',
    isLogin: true,
  },
  component:()=>import("@/pages/buy/contractList")
},
{
  path: '/shareApp',
  meta: {
    title: '无为股道',
  },
  component:()=>import("@/pages/shareApp/shareApp")
},
{
  path: '/bind',
  meta: {
    title: '绑定手机号',
  },
  component:()=>import("@/pages/shareApp/bind")
},
{
  path: '/dlApp',
  meta: {
    title: '下载APP',
  },
  component:()=>import("@/pages/shareApp/dlApp")
},
{
  path: '/privacy',
  meta: {
    title: '绑定手机号',
  },
  component:()=>import("@/pages/shareApp/privacy")
}
,{
  path: '/reSign',
  meta: {
    title: '重签协议',
  },
  component:()=>import("@/pages/reSign/index")
},
{
  path: '/courseColumn',
  meta: {
    title: '课程专栏',
    isLogin:true
  },
  component:()=>import("@/pages/courseColumn/index")
},
{
  path: '/productList',
  name: 'productList',
  meta: {
    title: '产品聚合',
  },
  component:()=>import("@/pages/productCollection/index")
  },
{
  path: '/productList-two',
  name: 'productList2',
  meta: {
    title: '产品聚合',
  },
  component:()=>import("@/pages/productCollection/index2")
}
]
export const routesArr = routes
